import type { SearchScenariosQuery } from '@predium/client-graphql';
import { useEntitySearch } from '@/components/global-search/hooks/useEntitySearch';
import { getScenarioItems } from '@/components/global-search/utils';
import { SEARCH_SCENARIOS } from '@/graphql/ActionPlanning.queries';

type Scenario = SearchScenariosQuery['scenario'][0];

const scenarioDataExtractor = (data: SearchScenariosQuery | undefined): Scenario[] => data?.scenario ?? [];

export function useSearchScenario(searchText: string) {
  const { data, loading, error } = useEntitySearch<SearchScenariosQuery, Scenario>({
    query: SEARCH_SCENARIOS,
    dataExtractor: scenarioDataExtractor,
    searchText,
  });

  return {
    scenarios: getScenarioItems(data),
    loading,
    error,
  };
}
